import '../../App.css';
import React from 'react';
import Header from '../../components/Header/Header';
import Body from '../../components/Body/Body';

const DashboardPage = () => {
    return (
        <div className="dashboard">
            <Header />
            <Body />
        </div>
    )
}

export default DashboardPage;
